import { format } from 'date-fns-tz';

import { getLinkTextCellColumn } from 'src/app/components/lib/table';

import type { GridColDef } from '@mui/x-data-grid-pro';

export function usePushColumns() {
  const baseColumns: GridColDef[] = [
    getLinkTextCellColumn({
      field: 'name',
      headerName: 'Name',
      valueGetter: (params) => {
        const { row } = params;
        return `${String(row.FirstName)} ${String(row.LastName)}`;
      },
    }),
    {
      field: 'SentUtc',
      headerName: 'Sent',
      valueGetter: ({ row }) => (row.SentUtc ? format(new Date(`${String(row.SentUtc)}`), 'MM/dd/yyyy hh:mm a') : '--'),
      sortable: false,
    },
    {
      field: 'OpenedUtc',
      headerName: 'Opened',
      valueGetter: ({ row }) =>
        row.OpenedUtc ? format(new Date(`${String(row.OpenedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
  ];

  return baseColumns;
}
